<div class="runway-detail section" [id]="runway.uriFragment">
  <div class="section__header">
    <span class="icons-container">
      <mat-icon (click)="openEditRunwayDialog(runway)" *ngIf="editModeSet && isFlightDeckAdmin && isIslandSource" class="edit-icon" mat-tooltip="Edit Runway" aria-label="Button that opens popover that allows you to edit runways">edit</mat-icon>
      <mat-icon (click)="deleteRunway(runway)" *ngIf="editModeSet && isFlightDeckAdmin && isIslandSource" class="delete-icon" mat-tooltip="Delete Runway" aria-label="Button deletes runway">delete_outline</mat-icon>
    </span>
    <h2 class="section__header-text">{{type}} {{runway.name}}</h2>
  </div>
  <div class="section__body">
    <div class="runway-detail__header data-block">
      <div class="data-block__item">
        <div class="data-block__label runway-detail__data-block__label-runway-two-column">Dimensions:</div>
        <div class="data-block__value runway-detail__data-block__value-runway-two-column">
          <ng-container *ngIf="runway.length; else na">
            <span class="runway-detail__alert"
                  [class.runway-detail__alert--warning]="runway.type !== LandingSurfaceType.Helipad && runway.length <= 2500"
                  [class.runway-detail__alert--danger]="runway.type !== LandingSurfaceType.Helipad && runway.length <= 1200">
              {{runway.length | number}}
            </span>
            <ng-container *ngIf="runway.width >= 0">×</ng-container>
            <span class="runway-detail__alert"
                  [class.runway-detail__alert--warning]="runway.type !== LandingSurfaceType.Helipad && runway.width < 50"
                  [class.runway-detail__alert--danger]="runway.type !== LandingSurfaceType.Helipad && runway.width <= 35">
              {{runway.width | number}}
            </span>
            ft
            <br>
           (<span class="runway-detail__alert" [class.runway-detail__alert--warning]="runway.type !== LandingSurfaceType.Helipad && runway.length <= 2500" [class.runway-detail__alert--danger]="runway.type !== LandingSurfaceType.Helipad && runway.length <= 1200">{{runway.lengthMeters | number}}
            </span>
            <ng-container *ngIf="runway.width >= 0">×</ng-container>
            <span class="runway-detail__alert"
                  [class.runway-detail__alert--warning]="runway.type !== LandingSurfaceType.Helipad && runway.width < 50"
                  [class.runway-detail__alert--danger]="runway.type !== LandingSurfaceType.Helipad && runway.width <= 35">
              {{runway.widthMeters | number}}
            </span>
            m)
          </ng-container>
      </div>
    </div>
    <div class="data-block__item">
      <div class="data-block__label runway-detail__data-block__label-runway-two-column">Weight Bearing Cap:</div>
      <div class="data-block__value runway-detail__data-block__value-runway-two-column">
        <ng-container *ngIf="runway.wtBearing1Wheel || runway.wtBearing2Wheel || runway.wtBearing2WheelTandem || runway.wtBearing2WheelDblTandem; else na">
          <ng-container *ngIf="runway.wtBearing1Wheel">
            Single wheel: {{runway.wtBearing1Wheel | number}} lbs<br />
          </ng-container>
          <ng-container *ngIf="runway.wtBearing2Wheel">
            Double wheel: {{runway.wtBearing2Wheel | number}} lbs<br />
          </ng-container>
          <ng-container *ngIf="runway.wtBearing2WheelTandem">
            Double tandem: {{runway.wtBearing2WheelTandem | number}} lbs<br />
          </ng-container>
          <ng-container *ngIf="runway.wtBearing2WheelDblTandem">
            Dual double tandem: {{runway.wtBearing2WheelDblTandem | number}} lbs<br />
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div class="data-block__item">
      <div class="data-block__label runway-detail__data-block__label-runway-two-column">Surface:</div>
      <div class="data-block__value runway-detail__data-block__value-runway-two-column runway-detail__alert"
           [class.runway-detail__alert--warning]="surfaceWarning"
           [class.runway-detail__alert--danger]="surfaceDanger">
        <ng-container *ngIf="runway.surfaceReadable; else na">
          {{runway.surfaceReadable}}
        </ng-container>
      </div>
    </div>
    <div class="data-block__item">
      <div class="data-block__label runway-detail__data-block__label-runway-two-column">Runway Edge Lights:</div>
      <div class="data-block__value runway-detail__data-block__value-runway-two-column">
        <ng-container *ngIf="edgeLighting; else na">
          {{edgeLighting}}
        </ng-container>
      </div>
    </div>
    <div class="data-block__item">
      <div class="data-block__label">Comments:</div>
      <div class="data-block__value">
        <ng-container *ngVar="getRunwayRemarks() as runwayRemarks">
          <app-remark-list *ngIf="runwayRemarks.length; else na" [remarks]="runwayRemarks"
                           [compact]="true"></app-remark-list>
        </ng-container>
      </div>
    </div>
  </div>
  <table class="runway-detail__body data-block data-block--shaded-labels data-block--fixed">
    <tbody>
    <tr class="data-block__item" *ngIf="editModeSet && isFlightDeckAdmin
        && (runway.takeOffLandAreas == null || runway.takeOffLandAreas.length < 2)">
      <td class="data-block__label">Add Takeoff/Land Area:</td>
      <td class="data-block__value">
        <button id="add_area_btn" (click)="openEditRunwayAreaDialog(null)" mat-mini-fab *ngIf="editModeSet && isFlightDeckAdmin">
          <mat-icon aria-label="Add Runway Area">add</mat-icon>
        </button>
      </td>
    </tr>
    <tr class="data-block__item">
      <td class="data-block__label">Designator:</td>
      <td class="data-block__value" *ngFor="let area of runway.takeOffLandAreas">
        <span class="icons-container__designator">
          <mat-icon (click)="openEditRunwayAreaDialog(area)" *ngIf="editModeSet && isFlightDeckAdmin && isIslandSource" class="edit-icon" mat-tooltip="Edit Area" aria-label="Button that opens popover that allows you to edit areas">edit</mat-icon>
          <mat-icon (click)="deleteTakeoffLandArea(area)" *ngIf="editModeSet && isFlightDeckAdmin && isIslandSource" class="delete-icon" mat-tooltip="Delete Area" aria-label="Button deletes area">delete_outline</mat-icon>
        </span>
        <span class="runway-detail__designator">{{area.name}}</span>
      </td>
    </tr>
    <tr class="data-block__item">
      <td class="data-block__label">Elevation:</td>
      <td class="data-block__value" *ngFor="let area of runway.takeOffLandAreas">
        <ng-container *ngIf="isNumeric(area.elevation); else na">
          {{area.elevation | number}} ft
        </ng-container>
      </td>
    </tr>
    <tr *ngIf="runway.type !== LandingSurfaceType.Helipad" class="data-block__item">
      <td class="data-block__label">Heading:</td>
      <td class="data-block__value" *ngFor="let area of runway.takeOffLandAreas">
        <ng-container *ngIf="isNumeric(area.trueAlignment); else na">
          <ng-container *ngIf="isNumeric(magVariation)">
            {{getMagneticHeading(area)}}° magnetic
            <br>
          </ng-container>
          {{formatHeading(area.trueAlignment)}}° true
        </ng-container>
      </td>
    </tr>
    <tr *ngIf="runway.type === LandingSurfaceType.Runway" class="data-block__item">
      <td class="data-block__label">Gradient:</td>
      <td class="data-block__value" *ngFor="let area of runway.takeOffLandAreas">
            <span *ngIf="area.gradient; else na" class="runway-detail__alert"
                  [class.runway-detail__alert--warning]="Math.abs(area.gradient) >= 1"
                  [class.runway-detail__alert--danger]="Math.abs(area.gradient) >= 2">
              {{ Math.abs(area.gradient) }}% {{ getGradientDirection(area.gradient) }}
            </span>
      </td>
    </tr>
    <tr *ngIf="runway.type !== LandingSurfaceType.Helipad" class="data-block__item">
      <td class="data-block__label">Traffic Pattern:</td>
      <td class="data-block__value" *ngFor="let area of runway.takeOffLandAreas">
            <span *ngIf="area.trafficPatDirFixed !== null; else noTrafficPatternDir" class="runway-detail__alert"
                  [class.runway-detail__alert--warning]="area.trafficPatDirFixed === TrafficPatternDirection.Right">
              {{getTrafficPattern(area)}} Pattern
            </span>
      </td>
    </tr>
    <tr class="data-block__item">
      <td class="data-block__label">Markings:</td>
      <td class="data-block__value" *ngFor="let area of runway.takeOffLandAreas">
            <span *ngIf="area.markingsType; else na" class="runway-detail__alert"
                  [class.runway-detail__alert--warning]="getMarkingsWarning(area)">
              {{getMarkings(area)}}
            </span>
      </td>
    </tr>
    <tr *ngIf="runway.type === LandingSurfaceType.Runway" class="data-block__item">
      <td class="data-block__label">Approach Lighting:</td>
      <td class="data-block__value" *ngFor="let area of runway.takeOffLandAreas">
        <button id="add_lighting_btn" (click)="openEditLightingDialog(null, area)" mat-mini-fab *ngIf="editModeSet && isFlightDeckAdmin && isIslandSource">
          <mat-icon aria-label="Add Lighting">add</mat-icon>
        </button>
        <ul class="ul" *ngIf="area.approachLighting.length; else na">
          <li *ngFor="let lighting of area.approachLighting">
            <span class="icons-container__lighting">
              <mat-icon (click)="openEditLightingDialog(lighting, area)" *ngIf="editModeSet && isFlightDeckAdmin && isIslandSource" class="edit-icon" mat-tooltip="Edit Lighting" aria-label="Button that opens popover that allows you to edit lighting">edit</mat-icon>
              <mat-icon (click)="deleteLighting(lighting, area)" *ngIf="editModeSet && isFlightDeckAdmin && isIslandSource" class="delete-icon" mat-tooltip="Delete Lighting" aria-label="Button deletes lighting">delete_outline</mat-icon>
            </span>
            {{getApproachLightingType(lighting)}}: {{lighting.description}}
          </li>
        </ul>
      </td>
    </tr>
    <tr *ngIf="runway.type === LandingSurfaceType.Runway" class="data-block__item">
      <td class="data-block__label">Displaced Threshold:</td>
      <td class="data-block__value" *ngFor="let area of runway.takeOffLandAreas">
        <ng-container *ngIf="area.dispThresholdDistance; else na">
          {{area.dispThresholdDistance | number}} ft
        </ng-container>
      </td>
    </tr>
    <tr *ngIf="runway.type === LandingSurfaceType.Runway" class="data-block__item">
      <td class="data-block__label">ILS/LOC:</td>
      <td class="data-block__value" *ngFor="let area of runway.takeOffLandAreas">
        <ng-container *ngIf="area.ilsType !== null; else na">
          {{getIlsType(area)}}
        </ng-container>
      </td>
    </tr>
    <tr class="data-block__item">
      <td class="data-block__label">Obstructions:</td>
      <td class="data-block__value" *ngFor="let area of runway.takeOffLandAreas">
        <button id="add_obstacle_btn" (click)="openEditObstacleDialog(null, area)" mat-mini-fab *ngIf="editModeSet && isFlightDeckAdmin && isIslandSource">
          <mat-icon aria-label="Add Obstacle">add</mat-icon>
        </button>
        <ng-container *ngIf="area.obstacles.length; else na">
          <p *ngFor="let obstacle of area.obstacles">
            <span class="icons-container__obstructions">
              <mat-icon (click)="openEditObstacleDialog(obstacle, area)" *ngIf="editModeSet && isFlightDeckAdmin && isIslandSource" class="edit-icon" mat-tooltip="Edit Obstacle" aria-label="Button that opens popover that allows you to edit obstacles">edit</mat-icon>
              <mat-icon (click)="deleteObstacle(obstacle, area)" *ngIf="editModeSet && isFlightDeckAdmin && isIslandSource" class="delete-icon" mat-tooltip="Delete Obstacle" aria-label="Button deletes obstacle">delete_outline</mat-icon>
            </span>
            {{formatObstacle(obstacle)}}
          </p>
        </ng-container>
      </td>
    </tr>
    <tr class="data-block__item">
      <td class="data-block__label">Comments:</td>
      <td class="data-block__value" *ngFor="let area of runway.takeOffLandAreas">
        <div class="data-list"
             *ngIf="editModeSet || getAreaRemarksFAA(area).length >= 1 || getAreaRemarksAM(area).length > 0; else na">
          <app-data-item *ngFor="let remark of getAreaRemarksFAA(area)"
                         [source]="remark.sourceId" [compact]="true">
            {{ remark.text }}
          </app-data-item>
          <app-data-item [source]="5" [compact]="true" *ngIf="editModeSet || getAreaRemarksAM(area).length >= 1">
            <div class="runway-detail__list-edit">
              <div class="runway-detail__remark-header" *ngIf="editModeSet">
                <p>Add comment</p>
                <button id="add_btn" (click)="openEditRunwayRemarkDialog(null, area)" mat-mini-fab *ngIf="editModeSet">
                  <mat-icon aria-label="Add Runway Remark">add</mat-icon>
                </button>
              </div>
              <p *ngFor="let remark of getAreaRemarksAM(area); let i = index">
                <mat-icon (click)="openEditRunwayRemarkDialog(i, area)" *ngIf="editModeSet" class="edit-icon"
                          mat-tooltip="Edit" aria-label="Edit ruwnay remark">edit
                </mat-icon>
                <mat-icon (click)="deleteRunwayRemark(i, area)" *ngIf="editModeSet" class="delete-icon"
                          mat-tooltip="Delete" aria-label="Delete runway remark">delete_outline
                </mat-icon>
                {{ remark.text }}
              </p>
            </div>
          </app-data-item>
        </div>
        <!-- <ng-container *ngVar="getAreaRemarksFAA(area) as areaRemarks">
          <app-remark-list *ngIf="areaRemarks.length; else na" [remarks]="areaRemarks" [compact]="true"></app-remark-list>
        </ng-container> -->
      </td>
    </tr>
    </tbody>
  </table>
</div>
</div>
<ng-template #na>n/a</ng-template>
<ng-template #noTrafficPatternDir>Not provided. Assume LEFT traffic pattern</ng-template>
